
export default {
  name: 'VideoBlock',
  props: {
    blockOptions: {
      type: Object
    }
  }
}
